export default function lazy(fn: () => void) {
  if (window && 'requestIdleCallback' in window) {
    window.requestIdleCallback(fn);
  } else {
    setTimeout(fn, 1);
  }
}
